import { render, staticRenderFns } from "./MSortListBtn.vue?vue&type=template&id=4ca072a7&"
import script from "./MSortListBtn.vue?vue&type=script&lang=ts&"
export * from "./MSortListBtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports